import _ from 'lodash'

import {
  LIST_USER_SECOND_FACTORS_STARTED,
  LIST_USER_SECOND_FACTORS_COMPLETED,
  LIST_USER_SECOND_FACTORS_FAILED,
  CLEAR_STATES
} from '@/store/types'
import { marshalMFA } from '@/utils/marshal'

function getDefaultState () {
  return {
    loading: false,
    done: false,
    error: undefined,

    mfaDevices: []
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {
    firstlyCreatedFactor (state) {
      if (state.mfaDevices.length > 0) {
        return state.mfaDevices.sort(function (a, b) {
          // Earliest created_at be the first one
          return new Date(a.created_at) - new Date(b.created_at)
        })[0]
      }
      return {
        createdAt: ''
      }
    }
  },

  mutations: {
    [LIST_USER_SECOND_FACTORS_STARTED] (state) {
      state.loading = true
    },
    [LIST_USER_SECOND_FACTORS_COMPLETED] (state, secondFactors) {
      state.mfaDevices = _.cloneDeep(secondFactors.map(marshalMFA))
      state.loading = false
      state.done = true
    },
    [LIST_USER_SECOND_FACTORS_FAILED] (state, err) {
      console.error(err)
      state.loading = false
      // TODO: handle error cases
      state.error = err
    },

    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    async list ({ commit, rootState: { client = undefined } }, id) {
      try {
        commit(LIST_USER_SECOND_FACTORS_STARTED)
        const secondFactors = await client.managementClient.listSecondFactors(id)
        commit(LIST_USER_SECOND_FACTORS_COMPLETED, secondFactors || [])
      } catch (err) {
        commit(LIST_USER_SECOND_FACTORS_FAILED, err)
      }
    }
  }
}
